import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { class: "image-preview" };
const _hoisted_2 = {
    key: 0,
    class: "watermark"
};
const _hoisted_3 = { class: "calendar-preview mx-auto p-2" };
import '@fullcalendar/core/vdom'; // solves problem with Vite
import FullCalendar from '@fullcalendar/vue3';
import { useCalendarSettingsStore } from '../stores/calendarSettings';
import { useCalendarTemplatesStore } from '../stores/calendarTemplates';
import { useCalendarImagesStore } from '../stores/calendarImages';
import { useInitStore } from '../stores/init';
import ImageUpload from '../components/ImageUpload.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PhotoTemplate',
    setup(__props) {
        const calendarSettingsStore = useCalendarSettingsStore();
        const calendarTemplatesStore = useCalendarTemplatesStore();
        const calendarImagesStore = useCalendarImagesStore();
        const initStore = useInitStore();
        calendarSettingsStore.title.fontFace.fontName = 'Carnation';
        calendarSettingsStore.title.fontSize = 80;
        calendarSettingsStore.title.color = 'hsl(0 95.9% 60.92% / 1)';
        calendarSettingsStore.title.shadowColor = 'hsl(0 100% 24.2% / 0.57)';
        calendarSettingsStore.setDayNames('narrow');
        calendarSettingsStore.calendarOptions.titleFormat = { year: undefined, month: 'long' };
        calendarTemplatesStore.templateIndex = 2;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    _createVNode(ImageUpload, { imageIndex: 0 }),
                    (_unref(calendarImagesStore).imageSelected)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_2, "CustomCalendarMaker.com"))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(FullCalendar), {
                        ref: "fullcalendar",
                        options: _unref(calendarSettingsStore).calendarOptions
                    }, null, 8, ["options"])
                ])
            ], 64));
        };
    }
});
